import React from 'react';

export default function RequestReview({ values = {}, genders = [], states = [], lgas = [], maritalStatuses = [], onEdit, onConfirm, submitting = false, error }) {

  const findName = (list, id) => {
    if (!id) return 'N/A';
    const found = (list || []).find(i => String(i.id) === String(id));
    return found ? found.name : id;
  };

  const genderLabel = findName(genders, values.gender);
  const stateLabel = findName(states, values.state);
  const lgaLabel = findName(lgas, values.lga);
  const maritalLabel = findName(maritalStatuses, values.maritalStatus);

  return (
    <div className="px-8 py-8">
      <h4 className="text-xl font-semibold text-gray-800 mb-6">Please review your request</h4>

      <div className="bg-white rounded-lg shadow p-6 mb-6">
        <div className="grid md:grid-cols-2 gap-4">
          <div>
            <p className="text-sm text-gray-600">Name</p>
            <p className="font-semibold text-gray-800">{values.name}</p>
          </div>
          <div>
            <p className="text-sm text-gray-600">Phone</p>
            <p className="font-semibold text-gray-800">{values.phoneNumber}</p>
          </div>
          <div>
            <p className="text-sm text-gray-600">Age</p>
            <p className="font-semibold text-gray-800">{values.age}</p>
          </div>
          <div>
            <p className="text-sm text-gray-600">Gender</p>
            <p className="font-semibold text-gray-800">{genderLabel}</p>
          </div>
          <div>
            <p className="text-sm text-gray-600">Delivery Method</p>
            <p className="font-semibold text-gray-800">{values.deliveryMethod}</p>
          </div>
          <div>
            <p className="text-sm text-gray-600">State</p>
            <p className="font-semibold text-gray-800">{stateLabel}</p>
          </div>
          <div>
            <p className="text-sm text-gray-600">LGA</p>
            <p className="font-semibold text-gray-800">{lgaLabel}</p>
          </div>
          <div>
            <p className="text-sm text-gray-600">Marital Status</p>
            <p className="font-semibold text-gray-800">{maritalLabel}</p>
          </div>
          <div>
            <p className="text-sm text-gray-600">Address</p>
            <p className="font-semibold text-gray-800">{values.address || 'N/A'}</p>
          </div>
        </div>
      </div>

      <div className="mb-4 text-red-600 font-medium">
        {error}
      </div>

      <div className="flex gap-4">
        <button type="button" onClick={onEdit} className="flex-1 px-6 py-3 bg-gray-200 hover:bg-gray-300 text-gray-800 font-medium rounded-lg">Edit</button>
        <button type="button" onClick={onConfirm} className="flex-1 px-6 py-3 bg-gradient-to-r from-teal-600 to-blue-600 hover:from-teal-700 hover:to-blue-700 text-white font-bold rounded-lg">
          {submitting ? 'Submitting...' : 'Confirm and Submit'}
        </button>
      </div>
    </div>
  );
}
